import { KeepAlive } from "vue";
import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";

const routes:RouteRecordRaw[] = [
	{
		path: "/",
		redirect: "/workbench",
		component: () => { return import("@/layouts/index.vue"); },
		meta: { name: "首页", isMenu: false },
		children: [
			{
				path: "/workbench",
				redirect: "/workbench/index",
				component: () => { return import("@/views/workbench/index.vue"); },
				meta: { name: "工作台", isMenu: true, code: "SU_workbench", icon: "menu-home" },
				children: [
					{
						path: "/workbench/index",
						component: () => { return import("@/views/workbench/workIndex/index.vue"); },
						meta: { name: "工作台", isMenu: true, code: "SU_workbench_index", icon: "menu-circle" }
					}, {
						path: "/workbench/myApply",
						name: "MyApply",
						component: () => { return import("@/views/workbench/myApply/index.vue"); },
						meta: { name: "我的申请", isMenu: true, code: "SU_workbench_myApply", icon: "menu-circle", keepAlive: true }
					}, {
						path: "/workbench/myTodo",
						name: "MyTodo",
						component: () => { return import("@/views/workbench/myTodo/index.vue"); },
						meta: { name: "我的待办", isMenu: true, code: "SU_workbench_myTodo", icon: "menu-circle", keepAlive: true }
					}, {
						path: "/workbench/detail",
						component: () => { return import("@/views/workbench/detail/index.vue"); },
						meta: { name: "建档/变更详情", isMenu: false, code: "SU_workbench_detail", icon: "menu-circle" }
					}
				]
			},
			{
				path: "/allEnterpriseSuppliers",
				name: "AllEnterpriseSuppliers",
				component: () => { return import("@/views/allEnterpriseSuppliers/index.vue"); },
				meta: { name: "全部企业供应商", isMenu: true, code: "SU_allEnterpriseSuppliers", icon: "ico_menu_qygys", keepAlive: true }
			},
			{
				path: "/allEnterpriseSuppliers/filing",
				name: "AllEnterpriseSuppliersFiling",
				component: () => { return import("@/views/allEnterpriseSuppliers/editDetail.vue"); },
				meta: { name: "全部企业供应商建档", isMenu: false, code: "allEnterpriseSuppliersDetail", keepAlive: true }
			},
			{
				path: "/allEnterpriseSuppliers/detail",
				component: () => { return import("@/views/allEnterpriseSuppliers/detail.vue"); },
				meta: { name: "全部企业供应商详情", isMenu: false, code: "SU_allEnterpriseSuppliers_detail" }
			},
			{
				path: "/purchaseSupplierManage",
				component: () => { return import("@/views/purchaseSupplierManage/index.vue"); },
				meta: { name: "采购品类供应商管理", isMenu: true, code: "SU_procure", icon: "ico_menu_cggys" },
				children: [
					{
						path: "/purchaseSupplierManage/supplierList",
						name: "SupplierList",
						component: () => { return import("@/views/purchaseSupplierManage/supplierList/index.vue"); },
						meta: { name: "供应商列表", isMenu: true, code: "SU_list", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/purchaseSupplierManage/supplierDetail",
						component: () => { return import("@/views/purchaseSupplierManage/supplierList/detail.vue"); },
						meta: { name: "供应商详情", isMenu: false, code: "SU_list_detail", icon: "menu-circle" }
					},
					{
						path: "/purchaseSupplierManage/supplierList/add",
						name: "SupplierAdd",
						component: () => { return import("@/views/purchaseSupplierManage/supplierList/supplierAdd/addIndex.vue"); },
						meta: { name: "供应商准入", isMenu: false, code: "SU_addlist_add", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/purchaseSupplierManage/supplierAddList",
						name: "SupplierAddList",
						component: () => { return import("@/views/purchaseSupplierManage/supplierAddList/index.vue"); },
						meta: { name: "供应商准入管理", isMenu: true, code: "SU_addlist", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/purchaseSupplierManage/supplierApplyDetail",
						component: () => { return import("@/views/purchaseSupplierManage/supplierAddList/detail.vue"); },
						meta: { name: "供应商申请详情", isMenu: false, code: "SU_addlist_detail", icon: "menu-circle" }
					},
					{
						path: "/purchaseSupplierManage/supplierEditList",
						name: "SupplierEditList",
						component: () => { return import("@/views/purchaseSupplierManage/supplierEditList/index.vue"); },
						meta: { name: "供应商变更管理", isMenu: true, code: "SU_modifylist", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/purchaseSupplierManage/supplierList/edit",
						name: "SupplierEdit",
						component: () => { return import("@/views/purchaseSupplierManage/supplierList/supplierEdit/editIndex.vue"); },
						meta: { name: "供应商变更", isMenu: false, code: "SU_modifylist_edit", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/purchaseSupplierManage/supplierEditDetail",
						component: () => { return import("@/views/purchaseSupplierManage/supplierEditList/detail.vue"); },
						meta: { name: "供应商变更申请详情", isMenu: false, code: "SU_modifylist_detail", icon: "menu-circle" }
					},
					{
						path: "/purchaseSupplierManage/otherDetail",
						component: () => { return import("@/views/purchaseSupplierManage/supplierEditList/otherDetail.vue"); },
						meta: { name: "供应商变更申请详情", isMenu: false, code: "SU_modifylist_other_detail", icon: "menu-circle" }
					},
					{
						path: "/purchaseSupplierManage/preferableSupplier",
						name: "PreferableSupplier",
						component: () => { return import("@/views/purchaseSupplierManage/preferableSupplier/index.vue"); },
						meta: { name: "供应商优选管理", isMenu: true, code: "SU_preferredlist", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/purchaseSupplierManage/preferableSupplier/apply",
						name: "PreferableSupplierApply",
						component: () => { return import("@/views/purchaseSupplierManage/preferableSupplier/apply.vue"); },
						meta: { name: "供应商优选申请", isMenu: false, code: "SU_preferredlist_apply", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/purchaseSupplierManage/preferableSupplier/detail",
						component: () => { return import("@/views/purchaseSupplierManage/preferableSupplier/detail.vue"); },
						meta: { name: "供应商优选申请详情", isMenu: false, code: "SU_preferredlist_detail", icon: "menu-circle" }
					},
					{
						path: "/purchaseSupplierManage/categoryUpgrade",
						name: "CategoryUpgrade",
						component: () => { return import("@/views/purchaseSupplierManage/categoryUpgrade/index.vue"); },
						meta: { name: "品类升降级管理", isMenu: true, code: "SU_relegationlist", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/purchaseSupplierManage/categoryUpgrade/apply",
						name: "CategoryUpgradeApply",
						component: () => { return import("@/views/purchaseSupplierManage/categoryUpgrade/apply.vue"); },
						meta: { name: "品类升降级申请", isMenu: false, code: "SU_relegationlist_apply", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/purchaseSupplierManage/categoryUpgrade/detail",
						component: () => { return import("@/views/purchaseSupplierManage/categoryUpgrade/detail.vue"); },
						meta: { name: "品类升降级申请详情", isMenu: false, code: "SU_relegationlist_detail", icon: "menu-circle" }
					},
					{
						path: "/purchaseSupplierManage/regularAssessment",
						name: "RegularAssessment",
						component: () => { return import("@/views/purchaseSupplierManage/regularAssessment/index.vue"); },
						meta: { name: "考核管理", isMenu: true, code: "SU_examinelist", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/purchaseSupplierManage/regularAssessment/initiate",
						name: "RegularAssessmentInitiate",
						component: () => { return import("@/views/purchaseSupplierManage/regularAssessment/initiate.vue"); },
						meta: { name: "发起考核", isMenu: false, code: "SU_examinelist_initiate", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/purchaseSupplierManage/regularAssessment/initiateDetail",
						name: "RegularAssessmentInitiateDetail",
						component: () => { return import("@/views/purchaseSupplierManage/regularAssessment/initiateDetail.vue"); },
						meta: { name: "考核详情", isMenu: false, code: "SU_examinelist_initiate_detail", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/purchaseSupplierManage/regularAssessment/assessmentForm",
						name: "AssessmentForm",
						component: () => { return import("@/views/purchaseSupplierManage/regularAssessment/myAssessment/assessmentForm.vue"); },
						meta: { name: "供应商考核单处理", isMenu: false, code: "SU_examinelist_assessmentForm", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/purchaseSupplierManage/regularAssessment/scoreTableDetail",
						name: "ScoreTableDetail",
						component: () => { return import("@/views/purchaseSupplierManage/regularAssessment/myAssessment/components/dialogScoreTable.vue"); },
						meta: { name: "评分表详情", isMenu: false, code: "SU_examinelist_assessmentForm_scoretable", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/purchaseSupplierManage/regularAssessment/scorePersonDetail",
						name: "ScorePersonDetail",
						component: () => { return import("@/views/purchaseSupplierManage/regularAssessment/myAssessment/components/dialogLookScorer.vue"); },
						meta: { name: "评分人详情", isMenu: false, code: "SU_examinelist_assessmentForm_scoreperson", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/purchaseSupplierManage/regularAssessment/assessmentScore",
						name: "AssessmentScore",
						component: () => { return import("@/views/purchaseSupplierManage/regularAssessment/myAssessment/assessmentScore.vue"); },
						meta: { name: "考核评分", isMenu: false, code: "SU_examinelist_assessmentScore", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/purchaseSupplierManage/supplierOverview",
						component: () => { return import("@/views/purchaseSupplierManage/supplierOverview/index.vue"); },
						meta: { name: "供应商总览", isMenu: true, code: "SU_supplierview", icon: "menu-circle" }
					}
				]
			},
			{
				path: "/accountManage",
				component: () => { return import("@/views/accountManage/index.vue"); },
				meta: { name: "账号管理", isMenu: true, code: "SU_accountManage", icon: "menu-setting" },
				children: [
					{
						path: "/accountManage/supplierAccount",
						name: "SupplierAccount",
						component: () => { return import("@/views/accountManage/supplierAccount/index.vue"); },
						meta: { name: "账号管理", isMenu: true, code: "SU_accountManage_list", icon: "menu-circle", keepAlive: true }
					},
					{
						path: "/accountManage/roleConfig",
						component: () => { return import("@/views/accountManage/roleConfig/index.vue"); },
						meta: { name: "账号角色默认配置", isMenu: true, code: "SU_accountManage_role", icon: "menu-circle" }
					}
				]
			},
			{
				path: "/auditLog",
				name: "AuditLog",
				component: () => { return import("@/views/auditLog/index.vue"); },
				meta: { name: "审计日志", isMenu: true, code: "SU_auditLog", icon: "menu_dingdan", keepAlive: true }
			},
			{
				path: "/configCenter",
				component: () => { return import("@/views/configCenter/index.vue"); },
				meta: { name: "配置中心", isMenu: true, code: "SU_configCenter", icon: "menu_peizhi" }
			},
			{
				path: "/403",
				component: () => { return import("@/views/403/index.vue"); },
				meta: { name: "403", isMenu: false }
			}
		]
	}
];

// 扁平化路由
const flattenRoutes = (routes: RouteRecordRaw[]): RouteRecordRaw[] => {
	return routes.flatMap(route => {
		const flattenedChildren = route.children ? flattenRoutes(route.children) : [];
		return [route, ...flattenedChildren];
	});
};
const flatRoutes = [{
	path: "/",
	redirect: "/workbench",
	component: () => { return import("@/layouts/index.vue"); },
	meta: { name: "首页", isMenu: false },
	children: flattenRoutes(routes[0].children || [])
}];

const router = createRouter({
	history: createWebHistory(import.meta.env.VITE_ROUTERBASE),
	routes: flatRoutes
});

export { router, routes, flatRoutes };
